var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWaitingTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "svg_icon",
    viewBox: "0 0 28 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#243A53;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.1,18.4a12.3,12.3,0,0,0,1.4-5.7A12.8,12.8,0,1,0,12.7,25.5h0A4.2,4.2,0,0,0,16,27h7.7A4.3,4.3,0,0,0,28,22.7,4.3,4.3,0,0,0,24.1,18.4ZM11.7,22.7c0,.2.1.5.1.7A10.7,10.7,0,1,1,23.5,12.7a10.6,10.6,0,0,1-1.7,5.7H16A4.3,4.3,0,0,0,11.7,22.7Zm12,2.3H16a2.3,2.3,0,0,1,0-4.6h7.7a2.3,2.3,0,0,1,0,4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.6,11.8v2H13.4a.9.9,0,0,1-.7.3,1.2,1.2,0,0,1-1.2-1.3,1.4,1.4,0,0,1,.2-.6V3.7h2v8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.3,
    y: 21.8,
    width: 2,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.9,
    y: 21.8,
    width: 2,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 22.5,
    y: 21.8,
    width: 2,
    height: 1.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWaitingTime);
export default __webpack_public_path__ + "static/media/icon-waiting-time.929d656f3a6ff5a2fde2c5a64b5d82a6.svg";
export { ForwardRef as ReactComponent };